import React from 'react';
import { Trans } from 'translations';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import stopPropagation from 'util/dom/stop-propagation';
import Icon from 'components/icon';
import { Link } from 'react-router-dom';
import { PROFILE } from 'constants/page-names';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

function MigrosLoginButton({ isAuthenticated, username, login, logout, inline, big, routerRegistry, facet }) {
    const renderLoginButton = () => {
        return (
            <h1 className="migros-login-button--greeting u-reset">
                {isAuthenticated && <Icon className="migros-login--icon" size="medium" symbol="profil"/>}
                <div className="migros-login-button-text--greeting">{isAuthenticated ? username : <Trans path={'user.my_account'}/>}</div>
            </h1>
        );
    };
    const renderLoginItem = () => {
        if (isAuthenticated) {
            return (
                <Link rel="nofollow" className="u-reset" to={normaliseTrailingSlash(routerRegistry.get(PROFILE).url)}>
                    {renderLoginButton()}
                </Link>
            );
        }
        return (
            <span onClick={() => login()}>
                {renderLoginButton()}
            </span>
        );
    };
    return (
        <aside
            className={classnames('migros-login-button', `migros-login-button__${ facet }`, { 'migros-login-button__inline': inline })}>
            <div className="migros-login-button--row">
                {!inline && <div onClick={stopPropagation} className="migros-login-button--text">{renderLoginItem()}</div>}
                <div className="migros-login-button--button">
                    <button
                        rel="nofollow"
                        onClick={() => (isAuthenticated ? logout() : login())}
                        className={classnames('a-service-login a-service-login--dark a-service-login--lang-de u-reset', { 'a-service-login--big': big })}
                    >
                        {isAuthenticated ? <Trans path={'user.logout'}/> : <Trans path={'user.login'}/>}
                    </button>
                </div>
            </div>
        </aside>
    );
}

MigrosLoginButton.propTypes = {
    routerRegistry: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    username: PropTypes.string,
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    inline: PropTypes.bool,
    big: PropTypes.bool,
    facet: PropTypes.string,
};

MigrosLoginButton.defaultProps = {
    facet: 'base',
};

export default connect(
    reduxUtils.mapStateToProps({
        isAuthenticated: 'user.isAuthenticated',
        username: 'user.username',
        routerRegistry: 'router.registry',
    }),
    reduxUtils.mapDispatchToProps({
        login: 'user.login',
        logout: 'user.logout',
    }),
)(MigrosLoginButton);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/migros-login-button/index.js